export const NewRelic = window.NREUM;

export const noticeError = (err: any) => {
  NewRelic?.noticeError(err);
};
